import React from 'react';

export const Minus = () => (
    <svg width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <rect x="19" y="11" width="2" height="14" rx="1" transform="rotate(90 19 11)" />
    </svg>
);
